export const TROUBLESHOOT_STATS_REQUEST = "TROUBLESHOOT_STATS_REQUEST";
export const TROUBLESHOOT_STAT_SUCCESS = "TROUBLESHOOT_STAT_SUCCESS";
export const TROUBLESHOOT_STAT_ERROR = "TROUBLESHOOT_STAT_ERROR";

export const TROUBLESHOOT_STAT_KEYS = {
  TOTAL_ORDERS: "totalOrders",
  AWAITING_ORDERS: "awaitingOrders",
  TOTAL_SYNC_ORDERS: "totalSyncOrders",
};
